import React from 'react';

const displayViewModal = 'displayViewModal';
const displayViewSelectColumn = 'displayViewSelectColumn';
const displayViewSelectShowCaller = 'displayViewSelectShowCaller';

export const displayView = {
  displayViewModal,
  displayViewSelectColumn,
  displayViewSelectShowCaller,
};

const teleprompterWelcomeModal = 'teleprompterWelcomeModal';
const teleprompterSelectColumn = 'teleprompterSelectColumn';
const teleprompterSelectRow = 'teleprompterSelectRow';
const remotePrompterOnboardingModal = 'remotePrompterOnboardingModal';
const teleprompterWelcomeTitle = <h2>Welcome to our new Prompter View!</h2>;

export const teleprompter = {
  teleprompterWelcomeModal,
  teleprompterSelectColumn,
  teleprompterSelectRow,
  teleprompterWelcomeTitle,
  remotePrompterOnboardingModal,
};
